export default {
  0: { id: 0, title: '--- Select one ---' },
  13: { id: 13, title: 'CBSD' },
  14: { id: 14, title: 'CBSD + DP' },
  15: { id: 15, title: 'SAS' },
  16: { id: 16, title: 'CxM' },
  17: { id: 17, title: 'EUD' }
};



// WEBPACK FOOTER //
// ./src/dictionaries/DeviceTypes.js